import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Post from "./Post";

function PostList({ posts, emptyMessage = "Ingen indlæg endnu.", getPostLink }) {
  if (!posts?.length) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ py: 4 }}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Box>
      {posts.map((post) => (
        <Post
          key={post.post_uuid || post.recipe_uuid}
          post={post}
          variant="card"
          linkTo={
            getPostLink
              ? getPostLink(post)
              : post.recipe_uuid || post.post_type === "recipe"
                ? `/recipes/${post.permalink || post.recipe_uuid}`
                : `/posts/${post.permalink || post.post_uuid}`
          }
        />
      ))}
    </Box>
  );
}

export default PostList;
